<template>
    <div>
        <v-card-text>
            <v-row no-gutters>
                <v-btn v-for="(reportType, idx) in reportTypes" :key="idx" @click="requestReport(reportType)">
                    {{ reportType.name }}
                </v-btn>
            </v-row>
        </v-card-text>
        <Table
                :headers="headers"
                :items="reports"
                :loading="loading"
                :items-per-page="reportsPerPage"
                :server-items-length="totalReports"
                :page="page"
                @update:request="updateRequest"
                item-key="id"
                class="elevation-1"
        >
            <template v-slot:item.name="{ item }">
                {{ item.name }}
            </template>
            <template v-slot:item.created_at="{ item }">
                {{ item.created_at | dateTime }}
            </template>
            <template v-slot:item.download="{ item }">
                <v-btn icon x-small v-if="item.is_ready">
                    <a href="#" @click.prevent="download(item)">
                        <v-icon>save</v-icon>
                    </a>
                </v-btn>
            </template>
        </Table>
        <RequestReportModalView
            :show.sync="modals.report.show"
            @report:request="onReportRequest"
            :report-name="modals.report.name"
            :report-type="modals.report.type"
            :request-report="modals.report.request"
            :suggestions-unit="suggestionsUnit"
            :suggestions-parent-unit="suggestionsParentUnit"
            :child-id="modals.report.childId"
        />
        <v-overlay v-model="overlay" absolute>
            <h1>Отчет успешно запрошен, результат вы сможете скачать по завершению формирования</h1>
            <p>
                <v-btn color="success" @click="overlay = false">Закрыть</v-btn>
            </p>
        </v-overlay>
    </div>
</template>

<script>
  import { BASE } from '@/config'
  import {GET_REPORTS} from "@/requests/common";
  import {Table} from "@/components/common";
  import RequestReportModalView from "@/views/common/RequestReportModalView";
  import axios from 'axios'

  const REPORT_TYPES = {
    withDates: 'withDates',
    withUnit: 'withUnit',
    withParentUnit: 'withParentUnit',
    withCardEventSuccessPassages: 'withCardEventSuccessPassages',
    withCardEventDeniedPassages: 'withCardEventDeniedPassages',
    withCardTypes: 'withCardTypes',
    withCardStatuses: 'withCardStatuses',
    withPresence: 'withPresence',
  }

  const DEFAULT_MODAL_REPORT = {
    show: false,
    name: null,
    request: null,
    type: null,
    childId: null,
  }

  export default {
    components: {
      Table,
      RequestReportModalView
    },
    data() {
      return {
        headers: [
          { text: 'Отчет', value: 'name', sortable: false },
          { text: 'Запрошен', value: 'created_at', sortable: false },
          { text: 'Скачать', value: 'download', sortable: false },
        ],
        reports: [],
        page: 1,
        totalReports: 0,
        reportsPerPage: BASE.LIMIT,
        loading: false,
        modals: {
          report: {...DEFAULT_MODAL_REPORT}
        },
        reportTypes: [],
        overlay: false,
        suggestionsUnit: null,
        suggestionsParentUnit: null,
        downloadReport: null,
        interval: null,
      }
    },
    destroyed() {
      if (this.interval) {
        clearInterval(this.interval)
        this.interval = null
      }
    },
    mounted() {
      this.getData()
    },
    methods: {
      updateRequest({ page, itemsPerPage, offset }) {
        this.reportsPerPage = itemsPerPage
        this.page = page
        this.getData({ offset })
      },
      requestReport(reportType) {
        this.modals.report = {
          show: true,
          name: reportType.name,
          request: reportType.request,
          type: reportType.type,
          childId: this.childId || null,
        }
      },
      onReportRequest() {
        this.overlay = true
        this.page = 1
        this.modals.report = {...DEFAULT_MODAL_REPORT}
        this.interval = setInterval(this.getData, 10000);
        this.getData()
      },
      download(report) {
        const url = this.downloadReport.replace('$guid', report.guid)
        axios.get(url,
          {
            responseType: 'arraybuffer',
            headers: {
              'Content-Type': 'application/json',
            }
          })
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'report.xlsx')
            document.body.appendChild(link)
            link.click()
          })
          .catch(error => {
            this.$notify({
              type: 'error',
              text: `Не удалось загрузить отчет ${error}`
            })
          });
      },
      async getData(params = {}) {
        try {
          this.loading = true
          const { data: { results, count } } = await GET_REPORTS({
            limit: this.reportsPerPage,
            offset: (this.page - 1) * this.reportsPerPage,
            ...params
          })

          this.totalReports = count
          this.reports = results
        } catch (error) {
          this.$notify({
            type: 'error',
            text: 'Не удалось загрузить информацию об отчетах'
          })
        } finally {
          this.loading = false
        }
      },
    }
  }

  export {REPORT_TYPES}
</script>